/**
 * Selection of `SalesReport` (Sales Protokoll), shared by the page fragment and the block
 * project-sales-report-data, so both read the same fields.
 */
export const SALES_REPORT_SELECTION = `
  completed {
    type
    value
  }
  salesHakLocationState
  salesZsLocationState
`;
